import { useEffect, useState } from "react";
import { X } from "lucide-react";

// HARD DEADLINE - Data de morte fixa e imutável (Domingo 14/12 às 23:59 BRT)
const EXPIRATION_DATE = new Date('2025-12-14T23:59:59-03:00');

const BlackFridayBanner = () => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isVisible, setIsVisible] = useState(true);

  // Verificação IMEDIATA de expiração (antes de qualquer render)
  const isExpired = Date.now() > EXPIRATION_DATE.getTime();

  useEffect(() => {
    // Debug temporário - remover após confirmar funcionamento
    console.log('[BlackFridayBanner]', {
      now: new Date().toISOString(),
      expiration: EXPIRATION_DATE.toISOString(),
      isExpired
    });

    // Se já expirou, não faz nada
    if (isExpired) {
      setIsVisible(false);
      return;
    }

    // Check if banner was closed
    const bannerClosed = sessionStorage.getItem('blackFridayBannerClosed');
    if (bannerClosed) {
      setIsVisible(false);
      return;
    }

    const endTimestamp = EXPIRATION_DATE.getTime();

    const updateCountdown = () => {
      const now = Date.now();
      const distance = endTimestamp - now;

      if (distance < 0) {
        setIsVisible(false);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [isExpired]);

  // EARLY RETURN: Se expirou ou foi fechado, não renderiza NADA
  if (isExpired || !isVisible) return null;

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('blackFridayBannerClosed', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="sticky top-0 z-50 bg-gradient-to-r from-[hsl(0_84%_35%)] via-[hsl(0_84%_45%)] to-[hsl(0_84%_35%)] text-white">
      <div className="container mx-auto px-4 py-3 relative">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-4 text-sm md:text-base">
          <div className="flex items-center gap-2">
            <span className="animate-pulse text-xl">🚀</span>
            <span className="font-bold uppercase">CYBER WEEK - OFERTA DE LANÇAMENTO</span>
          </div>
          <span className="hidden sm:inline">•</span>
          <span className="font-semibold">Até domingo meia-noite</span>
          <span className="hidden md:inline">•</span>
          <div className="flex gap-1 md:gap-2 font-mono">
            <span className="bg-white/20 px-1.5 md:px-2 py-0.5 rounded">{timeLeft.days}d</span>
            <span className="bg-white/20 px-1.5 md:px-2 py-0.5 rounded">{timeLeft.hours}h</span>
            <span className="bg-white/20 px-1.5 md:px-2 py-0.5 rounded">{timeLeft.minutes}m</span>
          </div>
        </div>
        <button
          onClick={handleClose}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded transition-colors"
          aria-label="Fechar banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default BlackFridayBanner;
